import { Button, Typography } from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { useDialog } from "../../../common/components/dialog/useDialog";
import { CreateDevicesFromTemplateDialog } from "./CreateDevicesFromTemplateDialog";

const CreateDevicesFromTemplateDialogContainer = ({
  overlay = false,
}: {
  overlay?: boolean;
}): JSX.Element => {
  const { open, handleDialogOpen, handleDialogClose } = useDialog();

  return (
    <>
      <Button
        variant={overlay ? "contained" : "outlined"}
        size={overlay ? "medium" : "small"}
        startIcon={<AddOutlinedIcon />}
        onClick={handleDialogOpen}
      >
        <Typography variant="buttonMedium">
          New devices from template
        </Typography>
      </Button>

      <CreateDevicesFromTemplateDialog
        open={open}
        handleClose={handleDialogClose}
      />
    </>
  );
};

export default CreateDevicesFromTemplateDialogContainer;
